import React from "react";

export const Logo = ({ size = 34, className = "" }) => {
  const w = size * 1.35;
  return (
    <svg width={w} height={size} viewBox="0 0 64 48" fill="none" className={className}
      xmlns="http://www.w3.org/2000/svg" aria-label="OPNWiFi logo" data-testid="opnwifi-logo">
      <path d="M10 22 Q32 5 54 22" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" opacity="0.4" />
      <path d="M16 28 Q32 15 48 28" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" opacity="0.7" />
      <path d="M22 34 Q32 25 42 34" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" />
      <circle cx="32" cy="40" r="7" fill="currentColor" />
      <circle cx="29.3" cy="38.6" r="1.15" fill="var(--logo-face, #09090B)" />
      <circle cx="34.7" cy="38.6" r="1.15" fill="var(--logo-face, #09090B)" />
      <path d="M28.6 41.4 Q32 44.2 35.4 41.4" stroke="var(--logo-face, #09090B)" strokeWidth="1.3"
        strokeLinecap="round" fill="none" />
    </svg>
  );
};

export const Wordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <Logo size={30} className="text-foreground" />
    <span className="font-display text-xl font-bold tracking-tight">
      OPN<span className="text-muted-foreground">WiFi</span>
    </span>
  </div>
);
